import React, { useEffect } from "react";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import { Grid, Modal, Box, Button, Tooltip } from "@mui/material";
import BloodSugarChart from "./BloodSugarChart";
import BloodPressureChart from "./BloodPressureChart";
import PulseRate from "./PulseRate";
import TemperatureChart from "./TemperatureChart";
import { getChartDetails } from "../services/EMRServices/emrServices";
import { format } from "date-fns";
import WeightsChart from "./WeightsChart";
// import GCSChart from "../../../emergency/common/gcsChart/GCSChart";
// import { gcsData } from "../../../emergency/common/gcsChart/data";
export default function GynacVitalChart(props) {
  const [bloodPressure, setBloodPressure] = React.useState([]);
  const [bloodSugar, setBloodSugar] = React.useState([]);
  const [pulseRate, setPulseRate] = React.useState([]);
  const [temperatures, setTemperatures] = React.useState([]);
  const [weights, setWeights] = React.useState([]);

  useEffect(() => {
    if (props.openViewVitals === true) {
      getChartDetails(props.patientId)
        .then((response) => {
          setBloodPressure(response.data.result.bloodPressures);
          setBloodSugar(response.data.result.bloodSugars);
          setPulseRate(response.data.result.pulseRates);
          setTemperatures(response.data.result.temperatures);
          setWeights(response.data.result.weights);
        })
        .catch((response) => {
          console.log(response);
        });
    }
  }, [props.patientId, props.openViewVitals]);

  return (
    <div>
      <Modal
        open={props.openViewVitals}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "95%",
            height: "auto",
            maxHeight: "90%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            overflow: "scroll",
          }}
        >
          <div className="flex justify-between mb-2">
            <p className="font-bold">Vitals</p>
            <CancelPresentationIconButton
              className="text-red-600  rounded cursor-pointer"
              onClick={() => {
                props.setOpenViewVital(false);
              }}
            />
          </div>

          <div>
            {bloodPressure && bloodPressure?.length > 0 ? (
              <>
                <BloodPressureChart bloodPressure={bloodPressure} />
                <hr className="border my-2 divide-x-8 border-slate-300" />
              </>
            ) : (
              ""
            )}
            {pulseRate && pulseRate?.length > 0 ? (
              <>
                <PulseRate pulseRate={pulseRate} />
                <hr className="border my-2 divide-x-8 border-slate-300" />
              </>
            ) : (
              ""
            )}

            {bloodSugar && bloodSugar?.length > 0 ? (
              <>
                <BloodSugarChart bloodSugar={bloodSugar} />
                <hr className="border my-2 divide-x-8 border-slate-300" />
              </>
            ) : (
              ""
            )}
            {temperatures && temperatures?.length > 0 ? (
              <>
                <TemperatureChart temperatures={temperatures} />
                <hr className="border my-2 divide-x-8 border-slate-300" />
              </>
            ) : (
              ""
            )}
            {weights && weights?.length > 0 ? (
              <>
                <WeightsChart weights={weights} />
                <hr className="border my-2 divide-x-8 border-slate-300" />
              </>
            ) : (
              ""
            )}
            {props?.from === "etu" ? (
              <div>
                {/* <GCSChart data={gcsData} /> */}
              </div>
            ) : (
              ""
            )}
          </div>
        </Box>
      </Modal>
    </div>
  );
}

